import parse from "html-react-parser"
import React, { useState } from "react"
import { graphql, useStaticQuery, Link } from "gatsby"
import { useIntl } from "gatsby-plugin-react-intl"
import { Container, Row, Col, Form } from "react-bootstrap"
import StyledButton from "../../common/styledButton"
import Title from "../../common/title"
import "./blockTextMediaGeneric.scss"
import Media from "../../common/media"
import CartContext from "../../../context/CartContext"
import { useContext } from "react"
import {
  FormControl,
  InputLabel,
  FormHelperText,
  Select,
  MenuItem,
} from "@mui/material"
import { Controller, useForm } from "react-hook-form"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"

const BlockTextMediaGeneric = ({
  collectEx,
  info,
  pageTitle,
  id,
  featuredImage,
  price,
  priceChild,
  intro,
  content,
  fixedPrice,
}) => {
  const intl = useIntl()
  const classReverse =
    content.block_media_text_media_alignment === "right"
      ? "reverseImageRight"
      : ""

  const {
    experiences,
    show,
    setShow,
    addToCart,
    numChild,
    numAdults,
    startDate,
    setNumChild,
    setStartDate,
    setNumAdults,
    childPrice,
    setChildPrice,
    adultPrice,
    setAdultPrice,
    totalPrice,
    setTotalPrice,
  } = useContext(CartContext)
  const experience = {
    pageTitle,
    id,
    intro,
    featuredImage,
    price,
    priceChild,
    numChild,
    numAdults,
    startDate,
    adultPrice,
    totalPrice,
    childPrice,
  }
  const experienceExist = experiences.some(exp => exp.id === experience.id)
  const {
    formState: { errors },
  } = useForm()

  const handleChangeNumChild = event => {
    setNumChild(event.target.value)
  }
  const handleChangeNumAdults = event => {
    setNumAdults(event.target.value)
  }
  let adultPricing
  if (fixedPrice) {
    adultPricing = 1 * price
  } else {
    adultPricing = numAdults * price
  }
  const childPricing = numChild * priceChild
  const totalPricing = adultPricing + childPrice

  setChildPrice(childPricing)
  setAdultPrice(adultPricing)
  setTotalPrice(totalPricing)
  const data = useStaticQuery(graphql`
    query expMenuQuery {
      expMenuQueryEN: allBlockContentBlockCollectableExperiences(
        filter: { langcode: { eq: "en" }, popup_booking_cta: {title: {ne: "test"}} }
      ) {
        nodes {
          popup_booking_cta {
            title
            url
          }
        }
      }

      expMenuQueryFR: allBlockContentBlockCollectableExperiences(
        filter: { langcode: { eq: "fr" }, popup_booking_cta: {title: {ne: "test"}} }
      ) {
        nodes {
          popup_booking_cta {
            title
            url
          }
        }
      }
    }
  `)

  let dataMenuExperiencePlan
  switch (intl.locale) {
    case "fr":
      if (data.expMenuQueryFR) {
        dataMenuExperiencePlan = data.expMenuQueryFR.nodes[0]
      }
      break
    default:
      if (data.expMenuQueryEN) {
        dataMenuExperiencePlan = data.expMenuQueryEN.nodes[0]
      }
  }
  let isValid = true
  if (experienceExist) {
    isValid = false
  }
  const handleClick = () => {
    if (numAdults) {
      addToCart(experience, experienceExist)
      setShow("show")
    }
  }
  const CustomInput = React.forwardRef(({ value, onClick }, ref) => (
    <input
      id="daterange"
      type="text"
      value={value}
      onClick={onClick}
      onChange={() => {}}
      readOnly
      ref={ref}
    />
  ))
  return (
    <section
      id="collectable-experience"
      className={`blk-text-media-generic blk-spacing ${!isValid ? `validExp` : ``}`}
      data-scroll-section
    >
      <Container data-scroll data-scroll-speed="1.5">
        <form>
          <Row className={classReverse}>
            <Col md={7} xs={12} className="blk-text-media-generic-image">
              <div className="sectionImage animImgTop" data-scroll>
                {content.relationships.block_media_text_image && (
                  <Media media={content.relationships.block_media_text_image} />
                )}
              </div>
            </Col>
            <Col md={5} xs={12} className="blk-text-media-generic-content">
              {content.block_media_text_title && (
                <Title heading={3} text={content.block_media_text_title} />
              )}
              <div className="description">
                <div>
                  {parse(content.block_media_text_description.processed)}
                </div>
              </div>
              {content.block_media_text_link && (
                <StyledButton
                  type="transparent"
                  extraClass="btn-text-media"
                  path={content.block_media_text_link.url}
                  title={content.block_media_text_link.title}
                />
              )}
            </Col>
          </Row>
          <Row className="blk-text-media-generic-content formFooter dateRangePicker">
            <Col md={9}>
              {collectEx && (
                <>
                  {isValid && (
                    <>
                      <Row className="form-submitExp">
                        <Col
                          md={4}
                          className={priceChild ? "" : "noChildAllowed"}
                        >
                          <FormControl
                            sx={{ m: 1, width: 373 }}
                            required
                            error={errors.adults}
                          >
                            <InputLabel htmlFor="adults">
                              {intl.formatMessage({ id: "add-to-cart.adults" })}
                            </InputLabel>
                            <Select
                              id="adults"
                              label="adults"
                              onChange={handleChangeNumAdults}
                            >
                              <MenuItem value="1">1</MenuItem>
                              <MenuItem value="2">2</MenuItem>
                              <MenuItem value="3">3</MenuItem>
                              <MenuItem value="4">4</MenuItem>
                              <MenuItem value="5">5</MenuItem>
                              <MenuItem value="6">6</MenuItem>
                              <MenuItem value="7">7</MenuItem>
                              <MenuItem value="8">8</MenuItem>
                              <MenuItem value="9">9</MenuItem>
                              <MenuItem value="10">10</MenuItem>
                              <MenuItem value="11">11</MenuItem>
                              <MenuItem value="12">12</MenuItem>
                              <MenuItem value="13">13</MenuItem>
                              <MenuItem value="14">14</MenuItem>
                              <MenuItem value="15">15</MenuItem>
                            </Select>
                            {errors.adults &&
                              errors.adults.type === "required" && (
                                <FormHelperText>
                                  {intl.formatMessage({
                                    id: "form_validation.required",
                                  })}
                                </FormHelperText>
                              )}
                          </FormControl>
                        </Col>
                        {priceChild && (
                          <>
                            <Col md={4}>
                              <FormControl sx={{ m: 1, width: 373 }}>
                                <InputLabel htmlFor="children">
                                  {intl.formatMessage({
                                    id: "add-to-cart.children",
                                  })}
                                </InputLabel>
                                <Select
                                  id="children"
                                  label="children"
                                  onChange={handleChangeNumChild}
                                >
                                  <MenuItem value="0">0</MenuItem>
                                  <MenuItem value="1">1</MenuItem>
                                  <MenuItem value="2">2</MenuItem>
                                  <MenuItem value="3">3</MenuItem>
                                  <MenuItem value="4">4</MenuItem>
                                  <MenuItem value="5">5</MenuItem>
                                  <MenuItem value="6">6</MenuItem>
                                  <MenuItem value="7">7</MenuItem>
                                  <MenuItem value="8">8</MenuItem>
                                  <MenuItem value="10">10</MenuItem>
                                  <MenuItem value="11">11</MenuItem>
                                  <MenuItem value="12">12</MenuItem>
                                  <MenuItem value="13">13</MenuItem>
                                  <MenuItem value="14">14</MenuItem>
                                  <MenuItem value="15">15</MenuItem>
                                </Select>
                              </FormControl>
                            </Col>
                          </>
                        )}
                        <Col md={4}className="colDatePicker focused">
                          <FormControl required>
                            <div className="MuiFormControl-root">
                              <InputLabel htmlFor="daterange">
                                {intl.formatMessage({
                                  id: "add-to-cart.date",
                                })}
                              </InputLabel>
                              <DatePicker
                                onChange={date => setStartDate(date)}
                                selected={startDate}
                                dateFormat="dd MMMM yyyy"
                                id="daterange"
                                monthsShown={1}
                                minDate={new Date()}
                                locale={intl.locale}
                                customInput={<CustomInput />}
                              />
                            </div>
                          </FormControl>
                        </Col>
                      </Row>
                      <Row className="dateRangePicker"></Row>
                    </>
                  )}
                </>
              )}
            </Col>
            <Col md={3}>
              <div className="btnReserve_wrapper">
                <div className="btnReserve" data-scroll>
                  {collectEx && (
                    <>
                      {!isValid ? (
                        <Link
                          className="btn btnPrimary btnFinalize"
                          to={dataMenuExperiencePlan.popup_booking_cta?.url}
                        >
                          <span>
                            {intl.formatMessage({
                              id: "cart-link.msg-1",
                            })}
                          </span>
                        </Link>
                      ) : (
                        <button
                          type="submit"
                          onClick={handleClick}
                          className={"btn btnPrimary"}
                        >
                          <span>{info?.booking_cta_title}</span>
                        </button>
                      )}
                    </>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </form>
      </Container>
    </section>
  )
}

export default BlockTextMediaGeneric
